import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ListboxModule } from '@proget-shared/form/listbox';

import { PickListComponent } from './pick-list.component';

@NgModule({
  declarations: [
    PickListComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ListboxModule,
  ],
  exports: [
    PickListComponent,
  ],
})
export class PickListModule { }
